import React from 'react';
import { Link } from 'react-router-dom';

const Configuration = () => {
  const configSections = [
    {
      id: 1,
      title: 'Unidades de Medida',
      description: 'Gestione las unidades de medida disponibles para productos (UN, KG, M, L, etc.)',
      icon: '📏',
      path: '/configuration/units',
      count: 0,
      color: 'from-blue-500 to-blue-600',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600',
    },
    {
      id: 2,
      title: 'Conversiones',
      description: 'Configure las tasas de conversión entre diferentes unidades de medida',
      icon: '🔄',
      path: '/configuration/conversions',
      count: 0,
      color: 'from-teal-500 to-teal-600',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
    },
    {
      id: 3,
      title: 'Atributos',
      description: 'Configure atributos personalizados para productos (Color, Talla, Material, etc.)',
      icon: '🏷️',
      path: '/configuration/attributes',
      count: 0,
      color: 'from-purple-500 to-purple-600',
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600',
    },
    {
      id: 4,
      title: 'Almacenes',
      description: 'Administre los almacenes y ubicaciones físicas del inventario',
      icon: '🏢',
      path: '/configuration/warehouses',
      count: 0,
      color: 'from-green-500 to-green-600',
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600',
    },
    {
      id: 5,
      title: 'Proyectos',
      description: 'Gestione los proyectos activos y su información relacionada',
      icon: '📁',
      path: '/configuration/projects',
      count: 0,
      color: 'from-orange-500 to-orange-600',
      iconBg: 'bg-orange-100',
      iconColor: 'text-orange-600',
    },
    {
      id: 7,
      title: 'Áreas',
      description: 'Gestione las áreas de la empresa (Producción, Logística, etc.)',
      icon: '📌',
      path: '/configuration/areas',
      count: 0,
      color: 'from-indigo-500 to-indigo-600',
      iconBg: 'bg-indigo-100',
      iconColor: 'text-indigo-600',
    },
    {
      id: 8,
      title: 'Hitos',
      description: 'Configure los hitos de proyecto con nombre y fecha específica',
      icon: '🎯',
      path: '/configuration/milestones',
      count: 0,
      color: 'from-amber-500 to-amber-600',
      iconBg: 'bg-amber-100',
      iconColor: 'text-amber-600',
    },
    {
      id: 9,
      title: 'Series autonumeradas',
      description: 'Configure series que asignan automáticamente el siguiente número en documentos',
      icon: '🔢',
      path: '/configuration/document-number-series',
      count: 0,
      color: 'from-rose-500 to-rose-600',
      iconBg: 'bg-rose-100',
      iconColor: 'text-rose-600',
    },
    {
      id: 6,
      title: 'Puntos de Venta',
      description: 'Configure los puntos de venta y terminales del sistema',
      icon: '🖥️',
      path: '/configuration/point-of-sales',
      count: 0,
      color: 'from-teal-500 to-teal-600',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
    },
  ];

  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Configuración</h1>
          <p className="text-gray-600 mt-2">Gestión de datos maestros del sistema</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {configSections.map((section) => (
            <Link
              key={section.id}
              to={section.path}
              className="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-200 hover:border-teal-300 transform hover:-translate-y-1"
            >
              <div className={`bg-gradient-to-r ${section.color} p-6 text-white`}>
                <div className="flex items-center justify-between mb-2">
                  <div className={`${section.iconBg} ${section.iconColor} w-14 h-14 rounded-xl flex items-center justify-center text-3xl`}>
                    {section.icon}
                  </div>
                  <div className="bg-white bg-opacity-20 rounded-full px-3 py-1">
                    <span className="text-sm font-semibold">{section.count}</span>
                  </div>
                </div>
                <h2 className="text-xl font-bold">{section.title}</h2>
              </div>

              <div className="p-6">
                <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                  {section.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-teal-600 group-hover:text-teal-700">
                    Gestionar →
                  </span>
                  <svg
                    className="w-5 h-5 text-teal-600 group-hover:translate-x-1 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 bg-blue-50 border border-blue-200 rounded-xl p-6">
          <div className="flex items-start gap-3">
            <svg className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <h3 className="text-sm font-semibold text-blue-900 mb-1">Información</h3>
              <p className="text-sm text-blue-700">
                La configuración del sistema permite gestionar los datos maestros que se utilizan en todo el sistema.
                Los cambios realizados aquí afectarán a los módulos relacionados.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Configuration;
